import { CartUrl } from "../directives/utilities/urls";
export default function coursePreRequisitesList() {
    return {
        coursePreRequisitesListData: [],
        selectedCoursePreRequisitesData: [],
        byPassPrerequisites: false,
        showErrorMesage: false,
        showLoader: false,
        isSubmitting: false,
        cartUrl: CartUrl,
        message:'',
        bindCoursePreRequisites() {
            fetch('/api/Checkout/GetCoursePrerequisites', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        if (response.prerequisites.length <= 0) {
                            document.location.href = '/cart/grade-option-discount';
                        }else
                        Array.prototype.push.apply(this.coursePreRequisitesListData, response.prerequisites);
                        
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        nextStep(itemList, step) {
            if (this.selectedCoursePreRequisitesData.length > 0 && this.selectedCoursePreRequisitesData.length == itemList.length) {
                var prequisites = [];
                for (var item = 0; item < itemList.length > 0; itemList++) {
                    var coursePreRequisite = {
                        "SerialId": itemList[item].serialId,
                        "AcademicYear": itemList[item].academicYear,
                        "AcademicTerm": itemList[item].academicTerm,
                        "Checked": true
                    }
                    prequisites.push(coursePreRequisite);
                }

                fetch('/api/Checkout/SaveCoursePrerequisites', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "Prequisites": prequisites,                    
                    })
                }).then(response => {
                    return response.json();
                }).then(response => {

                    if (response.isSuccess) {
                        document.location.href = '/cart/grade-option-discount';
                    }
                    else {
                    this.message = response.messages.length > 0 ? response.messages.join(', ') : response.message;
                    }

                })
            } else {
                this.message = "Please select check box.";
            }
        },
        init() {
            this.coursePreRequisitesListData= [],
            this.bindCoursePreRequisites();           
        },
        handleSelectClickhandleSelectClick(item, checked) {      
         
            const found = this.selectedCoursePreRequisitesData.some(el => el.serialId === item.serialId && el.academicTerm === item.academicTerm && el.academicYear === item.academicYear);
            if (!found) this.selectedCoursePreRequisitesData.push(item);
            else {
                this.selectedCoursePreRequisitesData.splice(item);
            }
           
        }

    }
}